<script async setup type="ts">
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/vue'

const people = [
  { id: 11, name: '2023', unavailable: false },
  { id: 10, name: '2022', unavailable: false },
  { id: 9, name: '2021', unavailable: false },
  { id: 8, name: '2020', unavailable: false },
  { id: 7, name: '2019', unavailable: false },
  { id: 6, name: '2018', unavailable: false },
]

const route = useRoute()
const selectedPerson = ref(null)

if (route.params.year !== undefined) {
  selectedPerson.value = people.filter(x => x.name === route.params.year)[0]
}
else {
  selectedPerson.value = people[0]
}

// watch(selectedPerson, (selectedPerson, previous) => {
//   router.push({
//     path: `/champs/year/${selectedPerson.name}`
//   })
// })
</script>

<template>
  <div class="text-xl pt-5 sm:pt-0 sm:text-2xl text-black sg-medium pb-12 flex justify-center">
    <div class="absolute flex items-center">
      <div class="shrink-0 sg-bold dark:text-gray-50">
        Reigning Champions of
      </div>
      <div class="pl-2">
        <Listbox v-model="selectedPerson">
          <div class="relative sg-bold">
            <ListboxButton class="relative pl-0 pr-8 text-left cursor-pointer focus:outline-none">
              <span
                class="truncate sm:pt-0 text-xl sm:text-2xl underline decoration-7 decoration-green-500/50 dark:text-gray-50 sg-bold"
              >{{ selectedPerson.name }}</span>
              <div class="absolute inset-y-0 right-0 flex items-center pointer-events-none">
                <span class="i-mdi-arrow-down-thick text-3xl mt-1.5 -mr-1 text-green-500/50" />
              </div>
            </ListboxButton>

            <transition
              leave-active-class="transition duration-100 ease-in"
              leave-from-class="opacity-100"
              leave-to-class="opacity-0"
            >
              <ListboxOptions
                class="absolute py-1 w-24 mt-3 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-6 ring-green-500/50 dark:ring-green-800 ring-opacity-50 focus:outline-none sm:text-sm dark:bg-gray-900"
              >
                <ListboxOption
                  v-for="person in people"
                  :key="person.name"
                  v-slot="{ active, selected }"
                  :value="person"
                  as="template"
                >
                  <NuxtLink :to="`/champs/year/${person.name}`">
                    <li
                      class="cursor-pointer select-none relative py-1.5 pl-8" :class="[
                        active
                          ? 'text-green-800 bg-green-500/10 dark:text-gray-50 dark:bg-gray-700'
                          : 'text-green-800 dark:text-gray-50 dark:bg-gray-900',
                      ]"
                    >
                      <span>{{ person.name }}</span>
                      <div v-if="selected" class="absolute inset-y-0 left-0 flex items-center pl-2 text-green-800">
                        <span class="i-ion-checkmark-round text-green-800" />
                      </div>
                    </li>
                  </NuxtLink>
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </div>
        </Listbox>
      </div>
    </div>
  </div>
</template>

<style scoped>
/*.small-font {*/
/*  font-size: 12px;*/
/*}*/
</style>
